<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    export let value: string = null
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let placeholder: string
    export let values: { [key: string]: any }
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    $: if (values && dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
        if (!displayComponent) {
            value = null
        }
    }
</script>

{#if displayComponent}
    <div class="textarea-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <textarea bind:value {placeholder}></textarea>
    </div>
{/if}
